'use client';

import CheckboxField from '@/components/form/lib/InputField/CheckboxField';

/**
 * The two consents that used to live on `/apply/review`. They are the real
 * commitment moment in this flow — nothing is charged at submit, so the
 * 3-month agreement, not the payment sheet, is what the applicant is agreeing
 * to. They sit directly above Submit for that reason.
 */
function ApplicationTermsFields() {
  return (
    <div className='ApplicationTermsFields Signup-optins'>
      <div className='InputField-checkbox'>
        <CheckboxField
          label={
            'I understand that my membership will start once approved, and I agree to pay for 3 months of membership fees if I decide to cancel before then.'
          }
          name='paymentAgreement'
        />
      </div>
      <div className='InputField-checkbox'>
        <CheckboxField
          label={
            <span>
              By clicking here, I have read and hereby agree to the{' '}
              <a
                href='/terms'
                className='Signup-terms'
                target='_blank'
              >
                terms of use
              </a>
              , and I acknowledge that I have read the{' '}
              <a
                href='/privacy-policy'
                className='Signup-terms'
                target='_blank'
              >
                privacy policy
              </a>
              . I acknowledge that the information entered in this form may be
              utilized to assess my eligibility for Vivrelle membership, either
              through a background check or the verification of the identity I
              have provided herein.
            </span>
          }
          name='terms'
        />
      </div>
    </div>
  );
}

export default ApplicationTermsFields;
